import { render, staticRenderFns } from "./UsersListView.vue?vue&type=template&id=5b4bb2f9&scoped=true"
import script from "./UsersListView.vue?vue&type=script&lang=js"
export * from "./UsersListView.vue?vue&type=script&lang=js"
import style0 from "./UsersListView.vue?vue&type=style&index=0&id=5b4bb2f9&prod&lang=css"
import style1 from "./UsersListView.vue?vue&type=style&index=1&id=5b4bb2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bb2f9",
  null
  
)

export default component.exports